import { render, staticRenderFns } from "./createRefund.vue?vue&type=template&id=60020f17&scoped=true"
import script from "./createRefund.vue?vue&type=script&lang=js"
export * from "./createRefund.vue?vue&type=script&lang=js"
import style0 from "./createRefund.vue?vue&type=style&index=0&id=60020f17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60020f17",
  null
  
)

export default component.exports